import {Legend} from '../../shared/models';
import {LegendColor, LegendStyle} from '../../shared/enums';
import {MetricType} from '../../shared/metric-types';

export const chargesLegendForCfp: Legend = {
  text: 'Charges',
  color: LegendColor.ORANGE,
  style: LegendStyle.CIRCLE,
  metric: MetricType.ClinicalFingerprint,
  showBenchmarkOptionControl: false,
  showPercentileControl: false,
};

export const benchmarkLegendForCfp: Legend = {
  text: 'cFTE adj wRVUs Benchmark',
  color: LegendColor.GREY,
  style: LegendStyle.SQUARE,
  metric: MetricType.ClinicalFingerprint,
  showBenchmarkOptionControl: true,
  showPercentileControl: false,
};

export const varianceLegendsForCfp: Legend[] = [
  {
    text: 'Above Benchmark',
    color: LegendColor.GREEN,
    metric: MetricType.ClinicalFingerprint,
    style: LegendStyle.SQUARE,
    showBenchmarkOptionControl: false,
    showPercentileControl: false,
  },
  {
    text: 'Below Benchmark',
    color: LegendColor.RED,
    metric: MetricType.ClinicalFingerprint,
    style: LegendStyle.SQUARE,
    showBenchmarkOptionControl: false,
    showPercentileControl: false,
  },
  {
    text: 'No Data',
    color: LegendColor.GREY,
    metric: MetricType.ClinicalFingerprint,
    style: LegendStyle.SQUARE,
    showBenchmarkOptionControl: false,
    showPercentileControl: false,
  }, benchmarkLegendForCfp
];

export const cftAdjCountLegendForCfp: Legend = {
  text: 'cFTE adj. Count',
  color: LegendColor.TEAL,
  metric: MetricType.ClinicalFingerprint,
  style: LegendStyle.SQUARE,
  showPercentileControl: false,
  showBenchmarkOptionControl: false
};

export const actualWrvuLegendForCfp: Legend = {
  text: 'Actual wRVUs',
  color: LegendColor.TEAL,
  metric: MetricType.ClinicalFingerprint,
  style: LegendStyle.SQUARE,
  showPercentileControl: false
};
export const cfteWrvuLegendForCfp: Legend = {
  text: 'cFTE adj. wRVUs',
  color: LegendColor.TEAL,
  metric: MetricType.ClinicalFingerprint,
  style: LegendStyle.SQUARE,
  showPercentileControl: false
};

export const countLegendForCfp: Legend = {
  text: 'Count',
  color: LegendColor.TEAL,
  metric: MetricType.ClinicalFingerprint,
  style: LegendStyle.SQUARE,
  showPercentileControl: false,
  showBenchmarkOptionControl: false
};

